export default __webpack_public_path__ + "static/media/edit.63d5642a.svg";